module.exports = __webpack_public_path__ + "img/IMG_1156_L_Black.fbb4c188.jpg";